import React from 'react';
import { BonusesSection } from '../components/BonusesSection';
import { CostSection } from '../components/CostSection';
import { CountdownSection } from '../components/CountdownSection';
import { FaqSection } from '../components/FaqSection';
import { FinalCtaSection } from '../components/FinalCtaSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { Hero } from '../components/Hero';
import { IncludedSection } from '../components/IncludedSection';
import { OfferSection } from '../components/OfferSection';
import { ProblemSection } from '../components/ProblemSection';
import { SiteFooter } from '../components/SiteFooter';
import { StickyCta } from '../components/StickyCta';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { VolumesSection } from '../components/VolumesSection';
export function Landing() {
  return <div className="w-full bg-cream-100 font-sans text-forest-800" data-id="element-206" data-mp="m7by82l7fgec">
      <Hero data-id="element-207" data-mp="m5hdao9xnoa9" />
      <main data-id="element-208" data-mp="m58wwmelq0ub">
        <ProblemSection data-id="element-209" data-mp="29s8ojb3loy6" />
        <IncludedSection data-id="element-210" data-mp="2aaadvgj4vdh" />
        <VolumesSection data-id="element-211" data-mp="2blfbylpo966" />
        <BonusesSection data-id="element-212" data-mp="27nvfarb7dl8" />
        <CountdownSection data-id="element-213" data-mp="3tftnn2y6p2p3" />
        <OfferSection data-id="element-214" data-mp="3tfjvp9tkwlgr" />
        <GuaranteeSection data-id="element-215" data-mp="3tf0drt3xhx2q" />
        <TestimonialsSection data-id="element-216" data-mp="3peq9ckvsbepz" />
        <FaqSection data-id="element-217" data-mp="3pdydd8y9zez6" />
        <CostSection data-id="element-218" data-mp="3pfj9h308n5z5" />
        <FinalCtaSection data-id="element-219" data-mp="3pgu9qsuh5vli" />
      </main>
      <SiteFooter data-id="element-220" data-mp="3kg6jwahzfksv" />
      <StickyCta data-id="element-221" data-mp="3kgonxtavz3bc" />
    </div>;
}